import React from 'react';


export const RegistoOperacoes=[
    {
        title:"Registo",
        link:"Registo_Clientes"

    },
    {
        title:"Compra",
        link:"vendas_registo"

    }/*,
    {
        title:"Reembolso",
        link:"/admin/home/quantidade"

    },
    {
        title:"Subistituicao de contador",
        link:"/admin/home/gestVendas"

    },/*
    {
        title:"Pagamento da divida",
        link:"/admin/home/gestVendas"
        
    },
    
    {
        title:"Adicionar Divida",
        link:"/admin/home/gestVendas"

    },
    
    {
        title:"Desconto da Divida",
        link:"/admin/home/gestVendas"

    },
*/




]